import { render, staticRenderFns } from "./PiperunOpportunityConfig.vue?vue&type=template&id=6d039758&scoped=true&"
import script from "./PiperunOpportunityConfig.vue?vue&type=script&lang=ts&"
export * from "./PiperunOpportunityConfig.vue?vue&type=script&lang=ts&"
import style0 from "./PiperunOpportunityConfig.vue?vue&type=style&index=0&id=6d039758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d039758",
  null
  
)

export default component.exports